<template>
  <div class="innerWrapper">
    <div class="ui active inline loader" v-show="userStatus === 'unknown' || !emailLinkChecked"></div>
    <div v-show="userStatus === 'not signed in' && emailLinkChecked">
      <h3>Welcome to the Art of Memory software!</h3>
      <img class="ui large image" :src="appPathPrefix + '/static/img/aom.png'">
      <br>
      <p>If you have a subscription to the Art of Memory software, enter your email address to sign in.</p>
      <p>If you don’t have a subscription, you can <a href="https://artofmemory.com/preorder">learn more about the software here</a>.</p>
      <div class="ui fluid input" :class="{disabled: emailStatus === 'sending'}">
        <input id="email" autocomplete="off" placeholder="you@example.com" spellcheck="false" type="email" v-model="email" @focus="emailStatus = 'initial'" @keyup.enter="signInClick()">
      </div>
      <div class="ui primary button signIn" :class="{disabled: !email || email.indexOf('@') == -1 || emailStatus !== 'initial'}" @click="signInClick()">Sign In</div>
      <br>
      <div class="ui active inline loader" v-show="emailStatus === 'sending'"></div>
      <div class="ui success message" v-show="emailStatus === 'sent'">
        <div class="header">
          Email Sent
        </div>
        <p>We’ve sent you an email containing a sign-in link. Please open the email and click the link to sign in.</p>
        <p>Please contact us at support@artofmemory.com if you have any issues signing in.</p>
      </div>
      <div class="ui error message" v-show="emailStatus === 'no access'">
        <div class="header">
          Email Address Not Found
        </div>
        <p>We can’t find a subscription for that email address. Please email us at support@artofmemory.com if you believe this is an error.</p>
      </div>
    </div>
    <br><br>
    <br>
  </div>
</template>

<script>

const firebase = window.firebase
const firestore = firebase.firestore()

export default {
  name: 'signin',
  data () {
    return {
      appPathPrefix: window.location.hostname === 'localhost' ? '' : '',
      email: '',
      emailLinkChecked: false,
      emailStatus: 'initial',
      signingIn: false,
      userId: '',
      userStatus: 'unknown'
    }
  },
  created () {
    const self = this
    window.vmSignin = this
    this.checkEmailLinkSignin()
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        self.userStatus = 'not signed in'
      }
    })
  },
  methods: {
    checkEmailLinkSignin: function () {
      let cleanUri, email
      const self = this
      if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
        email = window.localStorage.getItem('emailForSignIn')
        if (!email) {
          email = window.prompt('Please provide your email for confirmation')
        }
        firebase.auth().signInWithEmailLink(email, window.location.href)
          .then(result => {
            window.localStorage.removeItem('emailForSignIn')
            // Remove sign in parameters from URL
            cleanUri = location.protocol + '//' + location.host + location.pathname
            window.history.replaceState({}, document.title, cleanUri)
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
            self.emailLinkChecked = true
          })
      } else {
        this.emailLinkChecked = true
      }
    },
    sendSignInEmail: function () {
      const self = this
      const actionCodeSettings = {
        url: window.location.href,
        handleCodeInApp: true
      }
      firebase.auth().sendSignInLinkToEmail(this.email, actionCodeSettings)
        .then(() => {
          window.localStorage.setItem('emailForSignIn', self.email)
          self.emailStatus = 'sent'
        })
        .catch(error => {
          console.error(error)
        })
    },
    signInClick: function () {
      const self = this
      let unsubscribe
      if (!this.email || this.email.indexOf('@') === -1) return
      // Blur email input - emailStatus is reset on focus
      document.getElementById('email').blur()
      this.emailStatus = 'sending'
      firestore.collection('appCheckAccess').add({
        emailLower: this.email.toLowerCase(),
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      })
        .then(function (docRef) {
          unsubscribe = firestore.collection('appCheckAccessResults').doc(docRef.id)
            .onSnapshot(function (doc) {
              if (doc.exists && doc.data().done) {
                if (doc.data().hasAccess) {
                  self.sendSignInEmail()
                } else {
                  self.emailStatus = 'no access'
                }
                // Stop listening
                unsubscribe()
              }
            })
        })
        .catch(function (error) {
          console.error('Error adding document: ', error)
        })
    }
  },
  props: ['text', 'user']
}
</script>

<style scoped>
  h3 {
    margin-top: 2rem;
  }
  .loader {
    margin-top: 1rem !important;
  }
  .signIn {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Signin.vue